import type ContentManager from '@tribal-worldwide-london/fa-content';
import {
  GetPdbShortDto,
  PdbShort,
} from '@tribal-worldwide-london/fa-pdb-service-vwg';
import {
  FoundRetailers,
  GetRetailerByDealerNumberDTO,
} from '@tribal-worldwide-london/fa-retailer-service-vwg';
import { throwResponseError } from '../utils/response';
import { GetCalculationForPcpProductRequestDto } from '@tribal-worldwide-london/fa-finance-service-vwg';

export type AppLoaderFunctionArgs = { params: { pdbId?: string } };

export interface AppLoaderData {
  appData?: PdbShort;
  retailersData?: FoundRetailers[];
  redirect?: string;
}

const appLoader = async (
  { retailerService, pdbService }: any,
  { params }: AppLoaderFunctionArgs,
  contentManager: Pick<ContentManager, 'get'>
) => {
  if (params.pdbId) {
    const { data: appData, code: appCode } = await pdbService.getPdbShort(
      new GetPdbShortDto(params.pdbId)
    );

    if (appCode > 400) {
      throwResponseError(appCode, contentManager);
    }

    const { data: retailersData, code: retailerCode } =
      await retailerService.getRetailerByDealerNumber(
        new GetRetailerByDealerNumberDTO(appData.retailerContact.retailerId)
      );

    return Promise.resolve({
      retailersData,
      appData,
    });
  }

  throwResponseError(400, contentManager);
};

export default appLoader;
